import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
// Testimonials for marquee rows
const shortTestimonialsRowA = [{
  quote: "First thing in years that didn't make me feel broken. It explained what was happening, not just told me to stop.",
  author: 'Thomas K.',
  details: '34, Berlin'
}, {
  quote: 'My focus came back within a week. I had no idea how much energy I was burning fighting myself.',
  author: 'Andrew P.',
  details: '29, Dublin'
}, {
  quote: 'No streak counting, no shame spirals. Just clarity about what dopamine was actually doing in my brain.',
  author: 'Christopher L.',
  details: '37, Denver'
}, {
  quote: 'I feel emotionally present with my partner again. That alone was worth ten times the price.',
  author: 'Ryan M.',
  details: '33, Vancouver'
}, {
  quote: 'Calm, intelligent, never preachy. It reads like a neuroscience essay, not a self-help manual.',
  author: 'Jonathan F.',
  details: '40, Boston'
}, {
  quote: "The urges didn't go away through force. They lost their emotional weight. Completely different feeling.",
  author: 'Lucas D.',
  details: '26, Lisbon'
}];
const shortTestimonialsRowB = [{
  quote: 'I sleep through the night now. I forgot what that even felt like as an adult.',
  author: 'Benjamin H.',
  details: '38, Sydney'
}, {
  quote: "I read it slowly over a weekend. By Monday something had shifted that I can't fully explain.",
  author: 'Samuel R.',
  details: '31, Manchester'
}, {
  quote: 'It treated me like an adult caught in a biological trap, not a weak person who lacked discipline.',
  author: 'Nathaniel B.',
  details: '36, Amsterdam'
}, {
  quote: 'The shame just quietly disappeared. I stopped hating myself in the mornings.',
  author: 'Oliver J.',
  details: '30, Edinburgh'
}, {
  quote: "It's not a quit-porn book. It's a how-your-brain-got-hijacked book. That distinction changed everything for me.",
  author: 'Henry C.',
  details: '42, Portland'
}, {
  quote: 'My anxiety baseline dropped within two weeks. I am genuinely calmer in my own body.',
  author: 'Elliot V.',
  details: '35, Stockholm'
}];
type ShortQuote = {
  quote: string;
  author: string;
  details: string;
};
function MarqueeCard({
  item
}: {
  item: ShortQuote;
}) {
  return <div className="shrink-0 w-[320px] sm:w-[380px] mx-3 bg-charcoal border border-gold/10 rounded-lg p-6 sm:p-7 text-left" data-id="element-122">
      <div className="flex text-gold mb-4" data-id="element-123">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-current" data-id="element-124" />)}
      </div>
      <p className="text-ivory/85 text-sm sm:text-base font-light leading-relaxed mb-5 min-h-[5.5rem]" data-id="element-125">
        "{item.quote}"
      </p>
      <div className="pt-4 border-t border-gold/10" data-id="element-126">
        <div className="text-ivory font-medium text-sm tracking-wide" data-id="element-127">
          {item.author}
        </div>
        <div className="text-ivory/50 text-xs mt-0.5" data-id="element-128">{item.details}</div>
      </div>
    </div>;
}
function MarqueeRow({
  items,
  direction = 'left',
  duration = 50
}: {
  items: ShortQuote[];
  direction?: 'left' | 'right';
  duration?: number;
}) {
  // Duplicate the items for seamless looping
  const loop = [...items, ...items];
  return <div className="relative overflow-hidden" style={{
    maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
    WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)'
  }} data-id="element-129">
      <motion.div className="flex w-max" animate={{
      x: direction === 'left' ? ['0%', '-50%'] : ['-50%', '0%']
    }} transition={{
      duration,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-130">
        {loop.map((item, i) => <MarqueeCard key={i} item={item} data-id="element-131" />)}
      </motion.div>
    </div>;
}
export function Testimonials() {
  return <section className="py-14 sm:py-16 bg-charcoal-light border-y border-gold/5 overflow-hidden" data-id="element-132">
      <div className="max-w-4xl mx-auto px-6 text-center mb-10 sm:mb-12" data-id="element-133">
        <div className="text-gold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-134">
          Reader Reflections
        </div>
        <h2 className="font-serif text-4xl sm:text-5xl text-ivory" data-id="element-135">
          Quiet Changes, Real Lives
        </h2>
      </div>

      {/* Auto-scrolling marquee rows */}
      <div className="space-y-6" data-id="element-136">
        <MarqueeRow items={shortTestimonialsRowA} direction="left" duration={60} data-id="element-137" />
        <MarqueeRow items={shortTestimonialsRowB} direction="right" duration={70} data-id="element-138" />
      </div>
    </section>;
}